"use strict"

angular.module("core")
.service("InvoicePrintButtonService", function(common, FlashBag, gettextCatalog, $q, ZebraPrinterService) {
    this.PDF_LETTER_FORMAT = "letter";
    this.PDF_RECEIPT_FORMAT = "receipt";

    this.downloadInvoicePDF = function(invoiceId, pdfFormat, invoiceService) {
        return invoiceService.downloadPDF(invoiceId, pdfFormat).$promise.then(function(data) {
            var file_data = data.file_data;
            if (file_data) {
                var file_name = data.file_name;
                common.downloadFile(file_data, file_name, {type: "application/pdf;charset=utf-8;"});
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There is an error while trying to generate the file."));
            }
        });
    }

    this.printReceiptPDF = function(invoiceId, invoiceService, forceSelectPrinter, dedicatedVendorId) {
        return invoiceService.downloadPDF(
            invoiceId,
            this.PDF_RECEIPT_FORMAT
        ).$promise.then(function onSuccess(data) {
            return ZebraPrinterService.defaultResponseCallback(data, forceSelectPrinter).then(function onSuccess() {
                if (!dedicatedVendorId) {
                    return
                }
                invoiceService.get(invoiceId).$promise.then(function onSuccess(invoice) {
                    if (!invoice.attachments_count && (invoice.signature_is_required_on_invoice || invoice.stamp_is_required_on_invoice)) {
                        FlashBag.warning(
                            gettextCatalog.getString(
                                "Ask the customer for sign and/or stamp, then take a picture of the invoice. Use the Picture button hereunder"
                            ),
                            false,
                            0,
                            true
                        )
                    }
                });
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-print-button/invoice-print-button.service.js
// module id = 413
// module chunks = 0